import type { FC } from "react";

import { AccountDashboardBanner as UIAccountDashboardBanner } from "@jti/loyalty/components/AccountDashboardBanner";

import type { accountDashboardBannerInputs } from "./AccountDashboardBanner.builder";

type AccountDashboardBannerBuilderProps = BuilderComponentProps<typeof accountDashboardBannerInputs>;

export const AccountDashboardBanner: FC<AccountDashboardBannerBuilderProps> = ({
  text,
  title,
  background,
  showCurrentTier,
  tiers,
}) => {
  return (
    <UIAccountDashboardBanner
      text={text}
      title={title}
      background={background}
      showCurrentTier={showCurrentTier}
      tiers={tiers}
      componentId="accountdashboardbanner" // this value is used in automation tests, in AEM it was constructed based on component's name derived from sling resource type
    />
  );
};
